import store from '../store';
import { toast } from '../components';
import { gameLogin } from '../operates';




var __paramsObject: any = {};

export function setGlobalParams(key, value);
export function setGlobalParams(map: any);
export function setGlobalParams(...args) {
    if (args.length == 2) {
        __paramsObject[args[0]] = args[1];
    } else if (args.length == 1) {
        for (let key in args[0]) {
            __paramsObject[key] = args[0][key];
        }
    }
}

export function deletetGlobalParams(name) {
    delete __paramsObject[name];
}

/* 检测设备 */
export function detectmob() {
    let u = navigator.userAgent; // app = navigator.appVersion;
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; // g
    let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
    if (isAndroid) {
        // 这个是安卓操作系统
        return 'Android';
    }
    if (isIOS) {
        // 这个是ios操作系统
        return 'IOS';
    }
}

/* 检测设备 转换为埋点需要的数据 */
export function _equipmentType(): String {
    let osTypeId: string = '1';
    if (detectmob() == 'Android') {
        osTypeId = '1';
    } else if (detectmob() == 'IOS') {
        osTypeId = '2';
    }
    return osTypeId;
}

/**
 * 加载图片颜色
 */
export let loadcolor = {
    color: '#FFDC00'
};

declare var window: any;

/**
 * 获取URL上的参数
 */
export function getQueryString(key) {
    if (window.location) {
        let search = window.location.search;
        if (search == '') {
            return '';
        }
        search = search.slice(1);
        let searchArr = search.split('&');
        let length = searchArr.length;
        for (let i = 0; i < length; i++) {
            let str = searchArr[i];
            let arr = str.split('=');
            if (arr[0] == key) {
                return arr[1];
            }
        }
    }
    return '';
}

/**
 * 取得url参，路由后面拼接参数获取用这个
 */
export function getUrlParam(key) {
    let url: string = window.location.href;
    let reg: RegExp = new RegExp('[?&]' + key + '=([^&#]+)');
    let query: any = url.match(reg);
    return query ? query[1] : '';
}

export let scrollToAnchor = (anchorName) => {
    if (anchorName) {
        let anchorElement = document.getElementById(anchorName);
        if (anchorElement) {
            anchorElement.scrollIntoView();
        }
    }
};

/**
 * 页面错误时登录  弃用
 */
export function initKeydel() {
    if (sessionStorage.xianzai_iscose == 'false' || getQueryString('code') == '' || getQueryString('code') == null) {//登录标志
        sessionStorage.xianzai_iscose = 'true';// 修改登录标志后跳转
        return new Promise((resolve) => {
            resolve({});
        }).then(() => {
            return true;
        });//解决报错
    } else {
        return store.user.fetch();
    }
}

/**
 * 起始登录  弃用
 */
export function initKeyindex() {
    if (!sessionStorage.Authorization) {
        if ((getQueryString('code') == '' || getQueryString('code') == null)) {
            return new Promise((resolve) => {
            }).then((obj) => {
            });
        } else {
            return store.user.fetch();
        }
    } else {
        return new Promise((resolve) => {
            resolve({});
        }).then((obj) => {
        });
    }
}

// 设置cookie
export function setCookie(cname, cvalue, exdays) {
    let d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + '; ' + expires;
}

// 设置游戏cookie 毫秒数
function setMilliecondCookie(cname, cvalue, exhours) {
    let d = new Date();
    d.setTime(d.getTime() + (exhours * 60 * 60 * 1000));
    let expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + '; ' + expires;
}

// 获取cookie
export function getCookie(cname) {
    let name = cname + '=';
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
    }
    return '';
}

// 清理cookie
export function clearCookie(name) {
    setCookie(name, '', -1);
    setMilliecondCookie(name, '', -1);
}

/*
* 微信网页授权
* */
export function initKey() {
    if (store.status.gameApp) {// 游戏页面
        store.user.partnerId = window.sessionStorage.getItem('__partnerId');
        store.status.openId = getUrlParam('openId') ? getUrlParam('openId') : window.localStorage.getItem('openId');  // openid
        window.localStorage.setItem('openId', store.status.openId);
        gameLogin();
        return new Promise((resolve) => {
            resolve(true);
        }).then((resolve) => {
            return false;
        });
    } else {// 微信页面
        if (getCookie('pub-token')) {
            return new Promise((resolve) => {
                resolve(true);
            }).then((resolve) => {
                return true;
            });
        } else {
            // let partnerId = getUrlParam('partnerId');
            // let myHash = partnerId ? '?partnerId=' + partnerId + location.hash : '';
            // if (location.href.indexOf('invitation') != -1) {
            //     myHash = '#!/giftBagList?partnerId=' + getUrlParam('partnerId')
            // }
            let myHash = window.location.origin
            // let myHash = "https://pub.gjyymall.com"

            let url: any = `${myHash}/api/pub/user/weixin/v1/login`
            // let url: any = defaultOption.appUrl

            let localtionwxUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + defaultOption.appId + '&redirect_uri=' + encodeURIComponent(url) + '&response_type=code&scope=snsapi_userinfo&state=' + encodeURIComponent(myHash) + '&connect_redirect=0#wechat_redirect'; // 微信地址
            location.replace(localtionwxUrl);

            return new Promise((resolve) => {
                return resolve(false);
            }).then((resolve) => {
                return false;
            });
        }
    }
}


export function setOption(option: RequestOption) {
    defaultOption = Object.assign(defaultOption, option);
}

export function uncaught(error: Error) {
}

export type RequestCatchAction = 'toast' | 'ignore' | 'throw';

export interface RequestOption {
    verifyData?: boolean;
    autoIncludeGlobalParams?: boolean;
    fetching?: boolean;
    catchAction?: RequestCatchAction;
    defaultMethod?: 'GET' | 'POST';
    url?: string;
    appId?: string;
    appUrl?: string
}

let defaultOption: RequestOption = {
    verifyData: true,
    catchAction: 'toast',
    fetching: false,
    autoIncludeGlobalParams: true,
    appId: store.status.gameId ? store.status.gameId : ''
};

function params2FormData(params: any, option: RequestOption) {
    let p = {};
    if (params) {
        p = Object.assign(p, params);
    }
    if (option.autoIncludeGlobalParams) {
        p = Object.assign(p, __paramsObject);
    }
    let formData = new FormData();
    let keys = Object.keys(p);
    for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        let val = p[keys[i]];
        if (Array.isArray(val)) {
            val.forEach((v) => {
                formData.append(key + '[]', v);
            });
        } else {
            formData.append(key, val);
        }
    }
    return formData;
}

let complex_types = ['Object', 'Array'];

function isComplexObject(object) {
    let str = Object.prototype.toString.call(object).match(/^\[object\s(.*)\]$/)[1];
    return complex_types.indexOf(str) > -1;
}

/**
 * 格式化参数
 * @export
 * @param {*} params 需要格式化的参数
 * @param {RequestOption} option 请求方法，没有可传 {}
 * @returns a=1&b=1
 */
export function params2QueryString(params: any, option: RequestOption) {
    let p = {};
    if (params) {
        p = Object.assign(p, params);
    }
    if (option.autoIncludeGlobalParams) {
        p = Object.assign(p, __paramsObject);
    }
    let keys = Object.keys(p);
    return keys.map(k => {
        let v = isComplexObject(p[k]) ? JSON.stringify(p[k]) : p[k];
        return k + '=' + v;
    }).join('&');
}

function getUrl(routeOrUrl: string, option: RequestOption) {
    if (/^https?\:/gi.test(routeOrUrl)) {
        return routeOrUrl;
    } else {
        let url = option.url;
        if (!url) {
            throw new Error('请设置默认的请求地址: utils/network/setOption');
        }
        if (routeOrUrl) {
            url += routeOrUrl;
        }
        return url;
    }
}

let __paramsHeaders = {
    osType: 6,
    accountType: 1,
    osTypeId: _equipmentType()
};

export function setParamsHeaders(headers: any) {
    Object.assign(__paramsHeaders, headers);
}

function _doRequest(route: string, method: string, params: any, option: RequestOption, header?: Object): Promise<any> {
    if (typeof (params) == 'undefined') {
        params = {};
    }
    let url = getUrl(route, option);
    let promise: Promise<any>;
    delete params.url;
    delete params.method;
    let paramsHeaders = Object.assign({}, __paramsHeaders, (header || {}));
    if (method == 'GET') {
        var query = params2QueryString(params, option);
        if (url.indexOf('?') > -1) {
            url += '&';
        } else {
            url += '?';
        }
        url += query;
        promise = fetch(url, {
            method: 'GET',
            headers: paramsHeaders,
            credentials: 'include'
        }) as Promise<any>;
    } else {
        let bodyParams: any;
        // 判断是传json格式还是FormData格式
        if (params.typeMethod == 'json') {
            delete params.typeMethod;
            bodyParams = JSON.stringify(params);
        } else {
            delete params.typeMethod;
            bodyParams = params2FormData(params, option);
        }
        delete params.method;
        promise = fetch(url, {
            mode: 'cors',
            credentials: 'include',
            method: method, // 'POST',
            headers: paramsHeaders,
            body: bodyParams,
        }) as Promise<any>;
    }
    promise = promise.then((response: any) => {
        /* 请求结果 */
        if (response.status === 200) { // 为200正常
            return response.json().then((json) => {
                return ({ response, json });
            });
        } else { // 否则返回response
            return new Promise((resolve) => {
                resolve(response);
            }).then((response) => {
                return ({ response });
            });
        }
    }).catch((reject: any) => {
        console.log("promise-reject1===>", reject)
    });
    promise = promise.then(({ response, json }) => {
        if (json) { // 如果请求成功
            if (!response.ok) {//如果请求失败
                return Promise.reject({
                    code: 0,
                    message: json.errDesc
                });
            }
            if (json.errCode == '500' || json.errCode == '503' || json.errCode == '502') {//服务器异常
                toast(json.errDesc);
                return json;
            }
            if (json.errCode == '401') { // token验证失败
                clearCookie('pub-token');
                initKey();
                return false;
            }
            if (json.errCode == '13999' || json.errCode == '14999' || json.errCode == '12013') {//非法请求
                if (!store.status.isApp) {
                    setTimeout(() => {
                        location.hash = '/';
                    }, 2000);
                }
                toast(json.errDesc);
                return Promise.reject({
                    code: 0,
                    message: json.errDesc
                });
            }
            return json;
        } else if (response.status == '429') {
            return {
                data: null,
                errCode: 5201314,
                errDesc: '您点的太快了歇一下吧！'
            };
        } else {
            return {
                data: null,
                errCode: 5211314,
                errDesc: '服务请求失败'
            };
        }
    }).catch((reject: any) => {
        console.log("promise-reject2===>", reject)
    });
    return promise;

}

function doRequest(route: string, method: string, params?: any, option?: RequestOption, header?: Object) {
    return new Promise((resolve, inject) => {
        if (!option) {
            option = defaultOption;
        } else {
            option = Object.assign(defaultOption, option);
        }

        let promise = _doRequest(route, method, params, option, header);
        if (option.catchAction == 'ignore') {
            promise = promise.catch(() => {
                return false;
            });
        } else if (option.catchAction == 'toast') {
            promise = promise.catch((errObj) => {
                inject(errObj);
            });
        } else {
            promise = promise.catch((err) => {
                inject(err);
            });
        }

        promise.then((ret) => {
            if (!!ret) {
                resolve(ret);
            }
        });
    });
}

export function post(route: string, params?: any, option?: RequestOption, header?: Object): Promise<any> {
    return doRequest(route, 'POST', params, option, header);
}

export function get(route: string, params?: any, option?: RequestOption, header?: Object): Promise<any> {
    return doRequest(route, 'GET', params, option, header);
}

export function request(route: string, params?: any, option?: RequestOption, header?: Object): Promise<any> {
    if (!defaultOption.defaultMethod) {
        throw new Error('请设置默认的请求方法:utils/network/setOption');
    }
    if (params.method) return doRequest(route, params.method, params, option, header);
    return doRequest(route, defaultOption.defaultMethod, params, option, header);
}

export async function Ajax(setting) {
    setting = setting || {};
    let data = '';
    setting.data = Object.assign({
        version_id: '1.0'
    }, setting.data);
    setting.method = setting.method || 'GET';
    setting.dataType = setting.dataType || 'json';
    setting.async = typeof setting.async == 'undefined' ? true : setting.async;
    setting.url = defaultOption.url + setting.url;
    if (typeof setting.data != 'undefined') {
        data = Object.keys(setting.data).map(function (key) {
            return encodeURIComponent(key) + '=' + encodeURIComponent(setting.data[key]);
        }).join('&');
    }
    let xhr = new XMLHttpRequest();
    if (setting.method.toUpperCase() == 'GET') {
        setting.url += '?' + data;
    }
    xhr.open(setting.method, setting.url, setting.async);
    if (typeof setting.success == 'function') {
        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4 && xhr.status == 200) {
                let response: any = xhr.responseText;
                response = eval('(' + response + ')');
                if (response.errCode == '2') {

                }
                if (setting.dataType == 'json') {
                    setting.success(response);
                } else if (setting.dataType == 'jsonp') {
                    eval(response);
                } else {
                    setting.success(response);
                }
            }
        };
    }
    if (setting.method.toUpperCase() != 'GET') {
        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    }
    // xhr.withCredentials = true; // 支持跨域发送cookies
    xhr.send(data);
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/network.ts